import common from '../common/common';

class I18NUtils {
  i18n = {};

  getKey(key) {
    if (common.isNullOrUndefined(key)) return '';
    let msg = key.split(/\.(.+)/);
    /*
    if(!this.i18n[msg[0]]){
      //do async handling
      this.loadBundle(msg[0]);
    }
    */
    let a = this.i18n[msg[0]];
    return (a && a[msg[1]]) || !1;
  }

  /*
  loadBundle(module){
    //fetch call to load a lang pack. below a sample call
    this.i18n[module]={title:'नमस्ते'};
  }
  */
  load(data) {
    this.i18n = data;
  }
}

export const i18nUtils = new I18NUtils();
export const locale = i18nUtils.getKey.bind(i18nUtils);
export const I18N = ({ code, tag, children }) => {
  const val = i18nUtils.getKey(code) || children;
  if (tag === false) {
    return val;
  }
  return <span>{val}</span>;
};



// WEBPACK FOOTER //
// ./utils/i18n.js